import React from "react";

const DonwloaduploadIcon = (props) => {
  let height = props?.height ? props?.height : 20;
  let width = props?.width ? props?.width : 20;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={width}
      height={height}
      x="0"
      y="0"
      viewBox="0 0 100 100"
      class=""
    >
      <g>
        <path
          d="M60.431 92.8a1.5 1.5 0 0 0 2.379 0l17.56-22.85a1.5 1.5 0 0 0-1.19-2.414h-9.46V39.85a1.5 1.5 0 0 0-1.5-1.5h-13.2a1.5 1.5 0 0 0-1.5 1.5v27.69h-9.46a1.5 1.5 0 0 0-1.189 2.414z"
          fill="currentColor"
          opacity="1"
          data-original="#000000"
        ></path>
        <path
          d="M31.84 62.29h13.2a1.5 1.5 0 0 0 1.5-1.5v-27.7H56a1.5 1.5 0 0 0 1.189-2.414l-17.56-22.85a1.554 1.554 0 0 0-2.379 0l-17.56 22.85a1.5 1.5 0 0 0 1.19 2.414h9.46v27.7a1.5 1.5 0 0 0 1.5 1.5z"
          fill="currentColor"
          opacity="1"
          data-original="#000000"
        ></path>
      </g>
    </svg>
  );
};

export default DonwloaduploadIcon;
